import CardComponent from "./CardComponent";

export class CompanyName extends CardComponent {

}
